<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  [style]="{ width: '30rem' }"
  header="Contact Information"
  (onHide)="onHide()">
  <div class="mb-2 left-sidebar clientdetails">
    <!-- <h1 class="mb-3"></h1> -->
    <div class="clientdetails-section scroll-box-hgt-drawer">
      <li class="p-3 add-col mb-2" *ngFor="let item of ClientAddresses">
        <ng-container
          *ngIf="
            clientType === 'client' || (clientType === 'prospect' && item?.cust)
          ">
          <div class="row">
            <div class="col-8">
              <div class="row align-items-right">
                <div class="col-12 justify-content-end d-flex">
                  <div class="text d-flex align-items-right">
                    <i
                      title="Delete"
                      class="icon-Delete me-1"
                      (click)="deleteCustomerContact(item)">
                    </i>
                  </div>
                </div>
              </div>
              <h3 class="mb-0">{{ item.purpose }}</h3>
              <div class="d-flex align-items-center mb-1">
                <span class="me-1"><strong>Name:</strong></span>
                <span class="text name me-1" (click)="openEditContact(item)"
                  ><a class="link"
                    ><u>{{ item.name }}</u></a
                  ></span
                >
                <span
                  class="badge bg-primary"
                  *ngIf="item.purpose === 'Business'"
                  >Primary</span
                >
              </div>
            </div>
            <div class="col-4">
              <div class="row align-items-center">
                <div
                  class="col d-flex align-items-center justify-content-between">
                  <div class="text d-flex align-items-center">
                    <i class="icon-Email me-1"></i>
                    <a class="email" [href]="item.emailLink">{{
                      item.email
                    }}</a>
                  </div>
                  <div class="text d-flex align-items-center">
                    <i class="icon-Call me-1"></i>
                    <a class="tel" [href]="item.phoneLink">{{ item.phone }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </li>
    </div>
  </div>
</p-drawer>
